module.exports = __webpack_public_path__ + "static/media/APIExposeIconInactive.dd8a5798.png";